import { OrganizationSubType } from '@common/entities';

export const PUBLIC_LIST_SUB_TYPES: OrganizationSubType[] = [
  'selfHelpAddressRa',
  'selfHelpAddressGa',
  'selfHelpAddressCommunity',
  'selfHelpAddressShGroup',
  'selfHelpAddressBa',
];
